import axios from "axios";
import { useQuery } from "react-query";

import { MarginProcessingError, NotesData } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export function useGetNotes(eventId: string, isNotes: boolean) {
  const apiURL = `${getAppConfigSetting("apiUrl")}${GET_MARGIN_CALLS}`;

  const fetchNotes = async () => {
    const { data } = await axios.get(`${apiURL}/${eventId}/audit-trail`, {
      withCredentials: true,
    });
    return data;
  };

  return useQuery<NotesData, MarginProcessingError>(
    [queryKeys.getCallsAndAlertsNotes, eventId],
    fetchNotes,
    {
      enabled: !!eventId && isNotes,
    }
  );
}
